var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('cc-form',{ref:"createDiscountProduct",attrs:{"config":_vm.formConfig,"labelWidth":"110px","rules":_vm.goodsRules,"size":"medium"},model:{value:(_vm.form),callback:function ($$v) {_vm.form=$$v},expression:"form"}}),_c('el-button',{attrs:{"type":"primary","size":"medium"},on:{"click":_vm.save}},[_vm._v("確定")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }